export default {
  'up&down': 0,
  'left&right': 1,
  '4dir': 2,
  '8dir': 3
};